/**
 * EVENT BUS — minimal pub/sub for cross-stage communication.
 */

const listeners = {};

export function on(event, fn) {
  if (!listeners[event]) listeners[event] = [];
  listeners[event].push(fn);
}

export function off(event, fn) {
  if (!listeners[event]) return;
  listeners[event] = listeners[event].filter(function (f) { return f !== fn; });
}

export function emit(event, data) {
  if (!listeners[event]) return;
  for (var i = 0; i < listeners[event].length; i++) {
    try {
      listeners[event][i](data);
    } catch (e) {
      console.warn("EventBus:", event, e);
    }
  }
}

export const EventBus = { on: on, off: off, emit: emit };

/** Clears all listeners (Vitest isolation). */
export function __resetEventBusListeners() {
  for (var k in listeners) delete listeners[k];
}
